module.exports = __webpack_public_path__ + "674cbdc56bbe18042fe53cee84542d17.pdf";